import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { InputLangComponent } from './modal/inputlang.component';
import { ConfirmComponent } from './modal/confirm.component';
import { ConfirmWithOptionsComponent } from './modal/confirm-with-options.component';
import { InformationComponent } from './modal/information.component';
import { OpenDirective } from './modal/open.directive';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { ImageCropperModule } from 'ngx-image-cropper';

import {
  OrderByPipe,
  SearchByPipe,
  PaginatePipe,
  InspectionStatusPipe,
  ProductLinePipe,
  ReportTypePipe,
  PointStatusPipe,
  NotapplicableraisonPipe,
  OrdinalPipe,
  LocalEntityPipe,
  ProfilPipe,
  ReportStatusPipe,
  UtcDatePipe,
  InputDatePipe,
  FormatDatePipe
} from './pipes/index';

import {
  DateValueAccessorDirective,
  SelectorComponent,
  AutofocusDirective,
  ValidationMessageComponent,
  Broadcaster,
  SmallValidationMessageComponent,
  EmailValidatorDirective,
  OrderSummariesComponent,
  MultipleSelectorComponent,
  RotateDirective,
  CropDirective,
  PermissionDirective,
  AutosizeDirective,
  CharacterFormatterDirective,
  DndDirective,
  NumberRangeDirective,
  InputIntegerDirective
} from './utils/index';

import { InspectionModelListComponent } from './shared/components/models/models-list.component';
import { ModelSectionListComponent } from './shared/components/sections/list.component';
import { ActionPlanItemStatusPipe } from './pipes/actionPlanItemStatus.pipe';
import {
  ReportPdfListComponent,
  AccessRightsEditComponent,
  InspectionFilterModalComponent,
  PresentationsModalComponent,
  NewVersionModalComponent,
  ContactsModalComponent,
  EditImageModalComponent,
  AnnotateModalComponent,
  CanvasDrawingComponent,
  InspectionPartsManagementModalComponent
} from './shared/components/index';
import { ModalComponent } from './modal/modal.component';
import { InspectionEditComponent } from './inspections/components/edit.component';
import { InspectionStatusComponent } from '../../inspectionmanager/app/shared/components/inspections/status.component';
import { EditJsonComponent } from './shared/components/edit-json/edit-json.component';
import { FileReaderComponent } from './modal/file-reader.component';

import { EditImageComponent } from './shared/components/photoeditor/edit-image/edit-image.component';
//import { AnnotationComponent } from './shared/components/photoeditor/annotation/annotation/annotation.component';
//import { AnnotationLayerComponent } from './shared/components/photoeditor/annotation/annotation/annotation-layer.component';
//import { AnnotationToolsComponent } from './shared/components/photoeditor/annotation/annotation/annotation-tools.component';
import { AnnotationModule } from './shared/components/photoeditor/annotation/annotation.module';
import { InspectionListComponent } from './inspections/components/list.component';
import { InspectionListPageComponent } from './inspections/pages/list.component';
import { InspectionFilterComponent } from './inspections/components/filter.component';
import { InstallationListComponent } from './inspections/components/installation-list.component';
import { InspectionListMenuComponent } from './menus/inspection-list.menu';
@NgModule({
  imports: [CommonModule, TranslateModule, FormsModule, ReactiveFormsModule, ScrollingModule, ImageCropperModule, AnnotationModule],
  declarations: [
    ModalComponent,
    ConfirmComponent,
    ConfirmWithOptionsComponent,
    InputLangComponent,
    OpenDirective,
    OrderByPipe,
    SearchByPipe,
    PaginatePipe,
    DateValueAccessorDirective,
    SelectorComponent,
    AutofocusDirective,
    ValidationMessageComponent,
    SmallValidationMessageComponent,
    EmailValidatorDirective,
    InspectionModelListComponent,
    ModelSectionListComponent,
    OrderSummariesComponent,
    InspectionStatusPipe,
    ProductLinePipe,
    ReportTypePipe,
    PointStatusPipe,
    MultipleSelectorComponent,
    ActionPlanItemStatusPipe,
    AccessRightsEditComponent,
    NotapplicableraisonPipe,
    RotateDirective,
    CropDirective,
    NumberRangeDirective,
    PermissionDirective,
    OrdinalPipe,
    LocalEntityPipe,
    ProfilPipe,
    ReportStatusPipe,
    InformationComponent,
    AutosizeDirective,
    CharacterFormatterDirective,
    UtcDatePipe,
    DndDirective,
    InspectionEditComponent,
    ReportPdfListComponent,
    InspectionStatusComponent,
    EditJsonComponent,
    FileReaderComponent,
    InputDatePipe,
    FormatDatePipe,
    InspectionFilterModalComponent,
    InspectionPartsManagementModalComponent,
    PresentationsModalComponent,
    ContactsModalComponent,
    NewVersionModalComponent,
    EditImageComponent,
    // AnnotationComponent,
    // AnnotationLayerComponent,
    EditImageModalComponent,
    AnnotateModalComponent,
    CanvasDrawingComponent,
    InputIntegerDirective,
    InspectionListPageComponent,
    InspectionListComponent,
    InspectionFilterComponent,
    InstallationListComponent,
    InspectionListMenuComponent
  ],

  exports: [
    ModalComponent,
    ConfirmComponent,
    ConfirmWithOptionsComponent,
    InputLangComponent,
    OrderByPipe,
    SearchByPipe,
    PaginatePipe,
    DateValueAccessorDirective,
    SelectorComponent,
    AutofocusDirective,
    ValidationMessageComponent,
    SmallValidationMessageComponent,
    EmailValidatorDirective,
    ModelSectionListComponent,
    OrderSummariesComponent,
    OpenDirective,
    InspectionModelListComponent,
    InspectionStatusPipe,
    ProductLinePipe,
    ReportTypePipe,
    PointStatusPipe,
    MultipleSelectorComponent,
    TranslateModule,
    ActionPlanItemStatusPipe,
    AccessRightsEditComponent,
    NotapplicableraisonPipe,
    RotateDirective,
    CropDirective,
    NumberRangeDirective,
    PermissionDirective,
    OrdinalPipe,
    LocalEntityPipe,
    ProfilPipe,
    ReportStatusPipe,
    InformationComponent,
    AutosizeDirective,
    CharacterFormatterDirective,
    UtcDatePipe,
    DndDirective,
    ScrollingModule,
    InspectionEditComponent,
    ReportPdfListComponent,
    InspectionStatusComponent,
    EditJsonComponent,
    FileReaderComponent,
    InputDatePipe,
    FormatDatePipe,
    InspectionFilterModalComponent,
    InspectionPartsManagementModalComponent,
    PresentationsModalComponent,
    ContactsModalComponent,
    NewVersionModalComponent,
    EditImageComponent,
    // AnnotationComponent,
    // AnnotationLayerComponent,
    EditImageModalComponent,
    AnnotateModalComponent,
    CanvasDrawingComponent,
    InputIntegerDirective,
    InspectionListPageComponent
  ],
  providers: [Broadcaster, ProfilPipe, LocalEntityPipe, InspectionStatusPipe]
})
export class SharedModule {}
